import type { ReviewProps } from '@/components/landing-page/components/review';
import { defaults } from '@/components/landing-page/components/review';
import { cn } from '@/utils/helper';
import v1 from '@/components/landing-page/components/review/review-v1.module.css';
import v2 from '@/components/landing-page/components/review/review-v2.module.css';

const Review = (props: ReviewProps) => {
  const { title = defaults.title, reviews = defaults.reviews } = props;

  return (
    <div className={cn(v1.Reviews, v2.Reviews)}>
      {title ? (
        <h2 data-testid='review-title' className={cn(v1.Title, v2.Title)} dangerouslySetInnerHTML={{ __html: title }} />
      ) : null}
      {reviews.length ? (
        <ul className={cn(v1.List, v2.List)}>
          {reviews.map((item, i) => (
            <li key={i} data-testid='review-item' className={cn(v1.Review, v2.Review)}>
              <div data-testid='review-message' className={cn(v1.Text, v2.Text)}>
                {item.message}
              </div>
              <div className={cn(v1.Info, v2.Info)}>
                <b data-testid='review-name' className={cn(v1.User, v2.User)}>
                  {item.name}
                </b>
                <span className={cn(v1.Link, v2.Link)}>
                  mehr auf
                  <span>&nbsp;</span>
                  <a href={item.link.href} target='_blank' rel='noreferrer'>
                    <b>{item.link.text}</b>
                  </a>
                </span>
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default Review;
